<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="false"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Customers" :screenName="getScreenName" />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
// import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "../../_services/storage";
import { getGlobalField } from "../../_store/helpers";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "customer-transaction",
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "No Transactions",
            message:
              "Currently there are no transactions for customers. Give them a call and sell them something today!",
          },
        },
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },

      tabs: CustomerTabs,
    };
  },
  computed: {
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      // config.filter = [["CustomerCode", "=", this.model.Code]];
      return config;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
    getScreenName() {
      return "Customers - Transactions";
    },
  },

  async created() {
    CommonStorage.clear("go_back_route");

    // Set the selected tab to the Transactions tab
    this.selectedIndex = GetIndexByTabName("Transactions");

    // Get the screen layout
    let response = await ScreenLayoutService.getByRoute("customer-transaction");
    if (response.data.value) {
      let config = JSON.parse(response.data.value[0].Definition);

      // Get the grid data fields
      let select = [];
      config.columns.forEach((column) => {
        if (!column.gridDataField && !column.dataField) {
          let globalField = getGlobalField(column.screenField);
          if (globalField.gridDataField) select.push(globalField.gridDataField);
          else if (globalField.dataField) select.push(globalField.dataField);
        } else {
          if (column.gridDataField) select.push(column.gridDataField);
          if (column.dataField) select.push(column.dataField);
        }
      });

      // Set the grid data fields
      if(select.length > 0) config.dataSourceConfig.select = ["ICFlag"].concat(select);
      this.report = { ...config }
    }
  },
  methods: {},
};
</script>
